module.exports = __webpack_public_path__ + "static/media/bank-bg.896242b0.png";